import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useState } from "react";
interface DeletePopoverProps {
  children: React.ReactNode;
  onDelete: () => void;
  title: string;
  subtitle: string;
}

export function DeletePopover({
  children,
  onDelete,
  title = "Delete",
  subtitle = "Are you sure you want to delete this and its related data?",
}: DeletePopoverProps) {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger>{children}</PopoverTrigger>
      <PopoverContent className="flex flex-col gap-2">
        <div className="text-md font-medium">{title}</div>
        <p className="text-sm">{subtitle}</p>
        <div className="flex items-center justify-end gap-2">
          <Button variant="secondary" size="sm" onClick={() => setOpen(false)}>
            Cancel
          </Button>

          <Button variant="destructive" size="sm" onClick={onDelete}>
            Delete
          </Button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
